{
  "senseResultats": "Cap resultat amb aquesta cerca.",
  "circuits": {
    "cerca": "Cerca circuit o servei…",
    "general": "General",
    "usos_one": "Usat per {{count}} servei",
    "usos_other": "Usat per {{count}} serveis",
    "unSolDefecte": "Només n'hi pot haver un: en marcar-lo, l'anterior deixa de ser-ho.",
    "ajudaActiu": "Un circuit inactiu no es pot assignar a serveis nous.",
    "resumTemps": "Si ningú no confirma, l'avís arriba al darrer nivell ({{n}}) al minut {{min}}.",
    "ajudaConfirmacio": "El temps de confirmació del tipus d'avís s'aplica dins de cada nivell.",
    "canalNivell": "{{canal}} al nivell {{n}}",
    "minut": "minut {{min}}",
    "ultim": "últim",
    "siNoConfirma": "Si ningú no confirma en",
    "minutsPassa": "min per cada canal (s'envien un darrere l'altre), passa al nivell {{n}}",
    "crea": "Crea el circuit",
    "senseNom": "Cal un nom per al circuit."
  },
  "canals": {
    "titol": "Canals i temps",
    "reglesTemps": "Com es calcula quan s'escala",
    "reglaConfirmacio": "Temps de confirmació del tipus d'avís",
    "reglaConfirmacioText": "Temps que es dona a cada persona avisada per confirmar abans de reintentar-ho. Es configura aquí, per tipus d'avís.",
    "reglaCircuit": "Espera de cada nivell del circuit",
    "reglaCircuitText": "Si ningú del nivell no confirma en aquest temps, l'avís passa al nivell següent. És el que decideix quan s'escala.",
    "veureCircuits": "Circuits d'escalat",
    "reglaDefecte": "Temps d'escalat per defecte",
    "reglaDefecteText": "Només s'aplica als nivells que no tenen una espera pròpia.",
    "veureConfiguracio": "Configuració general",
    "excepcions": "Serveis amb canals propis",
    "defecte": "Per defecte: {{canals}}",
    "senseExcepcions": "Tots els serveis actius fan servir els canals per defecte ({{canals}}).",
    "servei": "Servei",
    "edita": "Edita a Estructura",
    "obreServei": "Edita els canals de {{servei}} a Estructura"
  },
  "plantilles": {
    "cerca": "Cerca per títol, codi o tipus…",
    "totsTipus": "Tots els tipus",
    "altreTipus": "Un altre tipus…",
    "textos": "Textos del missatge",
    "incomplet": "Falta el títol o el cos",
    "ajudaIncomplet": "La versió en {{idioma}} no té títol o cos: qui tingui aquest idioma rebrà un missatge buit.",
    "insereixA": "Insereix la variable a «{{camp}}»",
    "ajudaVariables": "Es posen on tens el cursor a «{{camp}}».",
    "camps": {
      "titol": "Títol",
      "cos": "Cos del correu",
      "cosPush": "Notificació push",
      "cosVeu": "Locució"
    },
    "valorDe": "Exemple de {{variable}}",
    "crea": "Crea la plantilla",
    "senseCodi": "Cal un codi."
  },
  "importacio": {
    "passos": "Passos de la importació",
    "pas": {
      "servei": "Servei",
      "fitxer": "Fitxer",
      "columnes": "Columnes",
      "revisa": "Revisa",
      "importa": "Importa"
    },
    "titolPas": {
      "servei": "1. A quin servei afegeixes les persones?",
      "fitxer": "2. Tria el fitxer Excel",
      "columnes": "3. Indica quina columna correspon a cada camp",
      "revisa": "4. Revisa i importa"
    },
    "ajudaServei": "Cada servei té la seva pròpia llista de persones a informar.",
    "triaServei": "Tria un servei…",
    "llistaActual_one": "La llista actual d'aquest servei té {{count}} persona.",
    "llistaActual_other": "La llista actual d'aquest servei té {{count}} persones.",
    "sOmeten_one": "{{count}} (s'omet)",
    "sOmeten_other": "{{count}} (s'ometen)",
    "validacioLocal": "Recompte fet al navegador; pendent de validar al servidor.",
    "veureErrors_one": "Mostra la fila amb error",
    "veureErrors_other": "Mostra les {{count}} files amb errors",
    "errorGeneric": "Fila {{fila}}: {{text}}",
    "mode_one": "S'afegirà {{count}} persona a la llista actual ({{actuals}}). No se'n treu cap: per treure'n, fes-ho des de la llista del servei.",
    "mode_other": "S'afegiran {{count}} persones a la llista actual ({{actuals}}). No se'n treu cap: per treure'n, fes-ho des de la llista del servei.",
    "revalida": "Torna a validar",
    "veureLlista": "Veure la llista del servei",
    "obreServei": "Obre el servei a Estructura",
    "unAltre": "Importa un altre fitxer"
  },
  "informar": {
    "subtitol": "A qui s'informa de cada servei",
    "cerca": "Cerca servei, àrea o departament…",
    "obreServei": "Obre a Estructura",
    "tria": "Tria un servei per veure a qui s'informa."
  }
}
